import { render, staticRenderFns } from "./IOTAddUpdate.html?vue&type=template&id=1fbb1bf6&scoped=true&"
import script from "./IOTAddUpdate.vue?vue&type=script&lang=js&"
export * from "./IOTAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./IOTAddUpdate.vue?vue&type=style&index=0&id=1fbb1bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbb1bf6",
  null
  
)

export default component.exports